let ProjectConfig = {
    app: 'malenia',
    api_prefix: "/malenia-api",
    login_token_key: 'MaleniaToken',
    login_user_key: "Malenia-USER",
    doc_path: '/malenia-doc/index.html',
    main_site: 'https://malenia.iinti.cn/',
    footer: 'malenia-系统框架',
    copyRight: '2023 因体信息公司'
}

export default {
    ...ProjectConfig,
    wsBase: () => {
        let wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
        return wsProtocol + "//" + window.location.host + ProjectConfig.api_prefix + "/ws/";
    }
};